import r from"./_isPrototype.js";import t from"./_nativeKeys.js";var o=Object.prototype.hasOwnProperty;function e(e){if(!r(e))return t(e);var a=[];for(var n in Object(e))o.call(e,n)&&"constructor"!=n&&a.push(n);return a}export{e as default};
//# sourceMappingURL=_baseKeys.js.map
